import { z } from 'zod'

const displayNameSchema = z
  .string()
  .transform((value) => value.normalize('NFKC').trim().replace(/\s+/gu, ' '))
  .pipe(
    z
      .string()
      .min(1, 'Le pseudo est requis.')
      .max(24, 'Le pseudo ne peut pas dépasser 24 caractères.')
      .refine((value) => !/[\p{Cc}\p{Cf}]/u.test(value), 'Le pseudo contient un caractère invisible.'),
  )

const pinSchema = z.string().regex(/^\d{4}$/u, 'Le PIN doit contenir exactement quatre chiffres.')
const tripCodeSchema = z
  .string()
  .transform((value) => value.trim())
  .pipe(z.string().min(4, 'Le code du voyage est invalide.').max(64))

export function normalizeMemberName(value: string): string {
  return displayNameSchema.parse(value).toLocaleLowerCase('fr-FR')
}

export function parseDisplayName(value: string): string {
  return displayNameSchema.parse(value)
}

export function parsePin(value: string): string {
  return pinSchema.parse(value)
}

export function parseTripCode(value: string): string {
  return tripCodeSchema.parse(value)
}
